import { render } from "./TicketOverview.vue?vue&type=template&id=c1183d3e"
import script from "./TicketOverview.vue?vue&type=script&lang=js"
export * from "./TicketOverview.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\lis-ticket-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__